import { Routes, RouterModule } from '@angular/router';
import { PaymentFoundationTrusteeScreenComponent } from './payment-foundation-trustee.component';

const paymentFoundationTrusteeRoutes: Routes = [
];

export const PaymentFoundationTrusteeRouter = RouterModule.forChild(paymentFoundationTrusteeRoutes);